import { useLocation } from 'react-router-dom';
import { useSessionStorage } from './useSessionStorage';

export const PAGE_AFTER_LOGIN_KEY = 'pageAfterLogin';
export const QUERY_PARAMS_AFTER_LOGIN_KEY = 'queryParamsAfterLogin';

export const useSessionStoredUrl = () => {
	const pageAfterLogin = useSessionStorage(PAGE_AFTER_LOGIN_KEY);
	const queryParamsAfterLogin = useSessionStorage(QUERY_PARAMS_AFTER_LOGIN_KEY);
	const location = useLocation();

	return {
		pageAfterLogin,
		queryParamsAfterLogin,
		rememberCurrentPathName: () => {
			if (location.pathname !== '/') {
				pageAfterLogin.set(location.pathname);
			}
		},
	};
};
